import { IEntityDetails, OnEntitySelectCallback } from '../../types';

let latestSelectionSeq = 0;

export const navigateToEntityUrl = (
  onEntitySelect: OnEntitySelectCallback | undefined,
  entity: IEntityDetails,
  defaultUrl: string,
  navigate: (url: string) => void,
  onHandled?: () => void
): void => {
  if (!onEntitySelect) {
    navigate(defaultUrl);
    return;
  }
  const selectionSeq = ++latestSelectionSeq;
  const isSuperseded = () => selectionSeq !== latestSelectionSeq;
  let handledNotified = false;
  const notifyHandled = () => {
    if (handledNotified) return;
    handledNotified = true;
    onHandled?.();
  };
  const fallback = (err: unknown) => {
    console.error('onEntitySelect callback failed; falling back to default URL', err);
    if (isSuperseded()) return;
    navigate(defaultUrl);
  };
  const applyResult = (handled: boolean | void) => {
    if (handled === false) {
      notifyHandled();
      return;
    }
    if (isSuperseded()) return;
    navigate(defaultUrl);
  };
  try {
    const result = onEntitySelect(entity);
    if (result && typeof (result as Promise<unknown>).then === 'function') {
      notifyHandled();
      (result as Promise<boolean | void>).then(applyResult).catch(fallback);
    } else {
      applyResult(result as boolean | void);
    }
  } catch (err) {
    fallback(err);
  }
};
